// eslint-disable-next-line import/no-commonjs
module.exports = require('./lib/builder').default



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/@sanity/image-url/index.js
// module id = 166
// module chunks = 5